module.exports = __webpack_public_path__ + "img/fluent-drag-used.fd2f4a4f.svg";